<template>
  <div
    class="c-product-card type-horizontal"
    :class="{ 'is-card-soldout': item.mmsta == 'N' }"
  >
    <div class="product-thumb">
      <button type="button" class="thumb-button" @click="emit('detail', item)">
        <div class="product-img">
          <img
            v-if="isNoPcImage"
            src="@/assets/images/common/img_no_product.svg"
            alt="No Image"
          />
          <img
            v-else
            :src="imageFilePath"
            alt=""
            @error="() => (imageErrorYn = true)"
          />
        </div>
      </button>
    </div>
    <div class="product-info">
      <div v-show="!productBadgeEmptyYn" class="c-product-badge">
        <span v-if="item.setgdYn === 'Y'" class="badge type-skyblue">
          SET 제품
        </span>

        <span v-if="item.zzlqdCls == 'A'" class="badge type-purple">
          주제
        </span>
        <span v-if="item.zzlqdCls == 'B'" class="badge type-mint">
          경화제
        </span>
        <span v-if="item.zzlqdCls == 'C'" class="badge type-blue">
          경화촉진제
        </span>
        <span v-if="item.zzlqdCls == 'D'" class="badge type-violet">
          회석제
        </span>

        <span v-if="item.zzlqdtyCls == 'A'" class="badge type-olive">
          1액형
        </span>
        <span v-if="item.zzlqdtyCls == 'B'" class="badge type-olive">
          2액형
        </span>
        <span v-if="item.zzlqdtyCls == 'C'" class="badge type-olive">
          3액형
        </span>
      </div>
      <div class="c-product-category">
        <span class="path">{{ item.prodh1t }}</span>
        <span class="path">{{ item.prodh2t }}</span>
        <span class="path">{{ item.prodh3t }}</span>
      </div>
      <div class="product-code">{{ item.matnr }}</div>
      <strong class="product-name">{{ item.zzmaktx }}</strong>
      <div class="tooltip-box">
        <template v-if="item.statCd == 'C2'">
          <button
            type="button"
            class="btn-popover"
            data-popover-trigger="cancel1"
          >
            <i class="c-icon icon-popover size-small"></i>
            <span>{{ item.statNm }}</span>
          </button>
        </template>
        <template v-else>
          <button type="button" class="btn-popover">
            <span>{{ item.statNm }}</span>
          </button>
        </template>

        <div
          class="c-popover-detail type-small"
          data-popover="cancel1"
          v-if="item.canQty && item.canQty > 0"
        >
          <div class="text">
            취소사유 : {{ item.canName }}<br />
            취소일 : {{ item.canDate }}
          </div>
        </div>
      </div>
      <!-- 2025-01-10 추가/삭제 -->
      <div class="order-result">
        <div class="order-count">
          <span>주문수량({{ Number(item.goodsQty) }})</span>
          /
          <template v-if="item.statCd == '0'">
            <span>확정수량(-)</span>
          </template>
          <template v-else>
            <span>확정수량({{ Number(item.goodsQty - item.canQty) }})</span>
          </template>
          /
          <span>취소수량({{ Number(item.canQty) }})</span>
        </div>
        <div class="order-price">
          <div class="order-price-item">
            <strong class="label">주문금액</strong>
            <p class="price">{{ Number(item.goodsPrc).toLocaleString() }}원</p>
          </div>
        </div>
      </div>
      <!-- // 2025-01-10 추가/삭제 -->
    </div>
    <div class="card-dim">
      <p class="text">담당영업사원 통한 주문품 주문건</p>
      <i class="c-icon icon-check-circle"></i>
    </div>
  </div>
</template>

<script setup>
import { onMounted, defineProps, defineEmits, ref, computed } from "vue";
import Utils from "@/js/utils";
import { popoverTrigger } from "@/js/_ui";

const props = defineProps({
  item: {
    type: Object,
    require: true,
  },
  zempName: {
    type: String,
    require: true,
  },
});

const emit = defineEmits(["detail"]);
const FILE_CDN_URL = process.env.VUE_APP_FILE_CDN_URL;
const item = ref(props.item); // 제품
const imageErrorYn = ref(false);

onMounted(() => {
  popoverTrigger();
});

const productBadgeEmptyYn = computed(() => {
  return (
    item.value.setgdYn !== "Y" &&
    item.value.zzlqdCls !== "A" &&
    item.value.zzlqdCls !== "B" &&
    item.value.zzlqdCls !== "C" &&
    item.value.zzlqdCls !== "D" &&
    item.value.zzlqdtyCls !== "A" &&
    item.value.zzlqdtyCls !== "B" &&
    item.value.zzlqdtyCls !== "C"
  );
});

const isNoPcImage = computed(() => {
  return (
    Utils.isBlank(item.value.filePath) ||
    Utils.isBlank(item.value.physFileNm) ||
    imageErrorYn.value
  );
});

const imageFilePath = computed(() => {
  return FILE_CDN_URL + "/" + item.value.filePath + "/" + item.value.physFileNm;
});
</script>
